// Libs & utils
import moment from 'moment'
import { combineReducers } from 'redux'
import undoable, { includeAction } from 'redux-undo'

// Reducers
import { appReducer } from './components/app/reducers'
import { loginReducer } from './pages/login/reducers'
import { uiReducer } from './components/ui/reducers'

const zoomLevel = moment().add(168, 'hours').valueOf() - moment().valueOf()

/** @type {Object} TODO work out type of state */
export const initialState = {
  app: {
    past: [],
    present: {
      config: null,
      terminalVisits: [],
      terminalMaintenance: [],
      berthsOccupation: null,
      selectedVisit: undefined,
      selectedOrderId: undefined,
      selectedMaintenance: null,
      dateRange: {
        from: moment().startOf('day').valueOf(),
        to: moment().startOf('day').valueOf() + zoomLevel
      },
      dataRange: {
        from: moment().startOf('day').subtract(1, 'weeks').valueOf(),
        to: moment().endOf('day').add(2, 'months').valueOf()
      },
      activeOverlays: [],
      conflictModalDimensions: null,
      conflictModalConflicts: null
    },
    future: []
  },
  login: {
    auth: {
      username: null,
      token: null,
      refreshToken: null,
      timestamp: null,
      userRoles: [],
      terminalId: null
    }
  },
  ui: {
    zoomLevel: zoomLevel,
    terminalPlannerExpanded: false,
    menuDropdownExpanded: false,
    scrollBarWidth: 15
  }
}

export const combinedReducers = combineReducers({
  app: undoable(appReducer, {
    filter: includeAction(['UPDATE_TERMINAL_VISIT']),
    debug: false,
    ignoreInitialState: true,
    syncFilter: true
  }),
  login: loginReducer,
  ui: uiReducer
})
